import React, { useState } from 'react';
import { useAuth } from '../lib/auth';
import { useNavigate, Navigate } from 'react-router-dom';
import { Btn, Input, Label } from '../components/Ui';
import { formatApiErrorDetail } from '../lib/api';

const LOGIN_BG =
  'https://static.prod-images.emergentagent.com/jobs/66d7cf3f-3556-45cd-b50b-1168ad192a26/images/29d36cb794b5e82c1a1454692c65d3d145e743353178032b6ae99acd7c4bbefe.png';

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      nav('/');
    } catch (e) {
      setError(formatApiErrorDetail(e?.response?.data?.detail) || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div
        className="hidden md:block bg-ink"
        style={{
          backgroundImage: `url(${LOGIN_BG})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      <div className="flex items-center justify-center px-6 py-12 bg-white">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-sm"
          data-testid="login-form"
        >
          <div className="text-[10px] font-bold uppercase tracking-wide2 text-muted">
            BluPlanet
          </div>
          <h1 className="text-4xl font-semibold tracking-tight mt-1">Administracion</h1>
          <p className="text-sm text-muted mt-2">Acceso administrador</p>

          <div className="mt-10 space-y-4">
            <div>
              <Label>Email</Label>
              <Input
                data-testid="login-email"
                type="email"
                autoComplete="username"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <Label>Password</Label>
              <Input
                data-testid="login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            {error && (
              <div
                data-testid="login-error"
                className="border border-danger text-danger text-xs px-3 py-2"
              >
                {error}
              </div>
            )}
            <Btn
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              size="lg"
              className="w-full"
            >
              {loading ? 'Accediendo…' : 'Acceder'}
            </Btn>
          </div>
        </form>
      </div>
    </div>
  );
}
